export type ReleaseProfile = {
    fast: number;
    normal: number;
    slow: number;
    fastThreshold: number;
    slowThreshold: number;
};

export const DEFAULT_RELEASE_PROFILE: ReleaseProfile = {
    fast: 160,
    normal: 300,
    slow: 500,
    fastThreshold: 1.35,
    slowThreshold: 0.5,
};

export function readDrawerEdgeMaxPx(fallback = 48): number {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--drawer-edge-max').trim();
    const parsed = Number.parseFloat(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export function getEdgeResistedOffset(rawOffset: number, edgeMaxPx: number, decayDenominator: number): number {
    if (rawOffset === 0 || edgeMaxPx <= 0 || decayDenominator <= 0) return 0;
    const abs = Math.abs(rawOffset);
    const resisted = edgeMaxPx * (1 - Math.exp(-abs / decayDenominator));
    return rawOffset < 0 ? -resisted : resisted;
}

export function shouldCloseByDistanceOrFlick(
    distance: number,
    closeThreshold: number,
    speed: number,
    speedThreshold: number,
    flickMinDistance: number
): boolean {
    return distance >= closeThreshold || (distance >= flickMinDistance && speed >= speedThreshold);
}

export function getReleaseDurationMs(speed: number, p = DEFAULT_RELEASE_PROFILE): number {
    const s = Math.max(0, speed);
    const base = 1000 / Math.max(0.01, s);
    const t = base / (base + 1000);
    const eased = 1 - Math.cos((t * Math.PI) / 2);
    const duration = p.fast + (base - p.fast) * eased;
    return Math.round(Math.min(p.slow, duration));
}
